import { useState } from "react";
import { CircleHelp, ChevronDown } from "lucide-react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { cn } from "@/utils/cn";
import deloitteLogo from "@/imgs/Deloitte Logo.svg";

const navItems = [
  { label: "Dashboard", href: "/dashboard" },
  { label: "GRC", href: "/grcdashboard" },
  { label: "Draft Calendar", href: "/draftcalendar" },
  { label: "Settings", href: "/settings" },
  { label: "Message Log", href: "/message-monitor" }
];

export function AppLayout() {
  const [showHelpMenu, setShowHelpMenu] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const location = useLocation();

  return (
    <div className="app-container-react">
      <header className="app-header-react">
        <div className="menu-left-react">
          <div className="logo-menu-react">
            <img
              src={deloitteLogo}
              alt="Deloitte"
              className="deloitte-logo-react"
            />
          </div>
          <div className="application-menu-react">
            <div className="application-sub-title-container-react">
              <div className="application-sub-title-react">
                <span className="bar">|</span>
                <span className="application-name">Mable</span>
              </div>
            </div>
            <nav className="header-nav-react" aria-label="Primary">
              {navItems.map((item) => {
                const isActive =
                  (item.href === "/dashboard"
                    ? location.pathname === "/" || location.pathname.startsWith("/dashboard")
                    : location.pathname === item.href ||
                      location.pathname.startsWith(`${item.href}/`));

                return (
                  <NavLink key={item.label} to={item.href} className="header-tab-link">
                    <span
                      className={cn(
                        "header-tab-menu-container-react",
                        isActive && "active-link-text-react"
                      )}
                    >
                      <span className="header-tab-title-react">{item.label}</span>
                    </span>
                  </NavLink>
                );
              })}
            </nav>
          </div>
        </div>

        <div className="menu-right-react">
          <div className="header-container-react">
            <div className="question-menu-react">
              <button
                type="button"
                className="icon-button-react"
                onClick={() => {
                  setShowHelpMenu((open) => !open);
                  setShowUserMenu(false);
                }}
                aria-expanded={showHelpMenu}
                aria-haspopup="menu"
                aria-label="Have a question"
              >
                <CircleHelp className="header-help-icon" />
                <ChevronDown className={cn("header-chevron", showHelpMenu && "opened")} />
              </button>
              {showHelpMenu ? (
                <div className="question-dropdown-react" role="menu">
                  <a target="_blank" rel="noopener noreferrer" href="https://ddu.deloitte.com/">
                    User Guide
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://deloitteus.service-now.com/sp?id=sc_cat_item&sys_id=9d997dc0db16ac10eb90abc5ca961911&table=sc_cat_item"
                  >
                    Log an Issue
                  </a>
                </div>
              ) : null}
            </div>

            <div className="user-menu-anchor-react">
              <button
                type="button"
                className="profile-button-react"
                onClick={() => {
                  setShowUserMenu((open) => !open);
                  setShowHelpMenu(false);
                }}
                aria-expanded={showUserMenu}
                aria-haspopup="menu"
                aria-label="User menu"
              >
                <span className="profile-avatar-react">M</span>
              </button>
              {showUserMenu ? (
                <div className="user-menu-react" role="menu">
                  <button type="button" className="user-menu-item-react">
                    Log Out
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </header>

      <div className="body-react">
        <main className="content-react">
          <div className="router-react">
            <Outlet />
          </div>
        </main>
      </div>

      <footer className="footer-react">
        <div className="footer-container-react">
          <div className="footer-item-react">
            Copyright © {new Date().getFullYear()} Deloitte Development LLC. All rights reserved.
          </div>
          <div className="footer-item-react">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www2.deloitte.com/us/en/legal/privacy.html"
            >
              Privacy
            </a>
            <span className="footer-separator-react">|</span>
            <a target="_blank" rel="noopener noreferrer" href="https://cookienotice.deloitte.com">
              Cookies
            </a>
            <span className="footer-separator-react">|</span>
            <button type="button" className="footer-link-button-react">
              Cookie Settings
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
}
